import React from 'react';
import BrokerageOrderForm from 'Components/Banking/BrokerageOrderForm';
import './Brokerage.css';

// Kauf eines komplett neuen Wertpapiers ausschliesslich aus der Watchlist
// heraus (Kursdaten-Modul) - Nutzervorgabe vom 2026-07-26: "Neue Order" ohne
// Watchlist-Bezug gibt es nicht mehr, dafuer ist die Handelsplatz-Auswahl
// durch den einmaligen Watchlist-Abgleich (BrokerageTask::reconcileWatchlist())
// bereits ohne comdirect-Verbindung verfuegbar (BrokerageOrderForm liest sie
// aus dem Cache, siehe dortigen Kommentar).
//
// Umbau 2026-07-26 (Nutzerwunsch): Verbindung/Depot werden nicht mehr in
// eigenen Auswahl-Bildschirmen VOR der Order-Maske abgefragt, sondern sind
// Teil des Formulars selbst - ohne connectionId-Prop waehlt BrokerageOrderForm
// sie eigenstaendig aus dem lokalen Spiegel (im Gegensatz zum Verkauf einer
// bekannten Position, wo die Felder gesperrt/vorbelegt sind).
export default function BrokerageBuyFromWatchlist({ x, instrumentId, instrumentLabel, instrumentIsin, custodyCountry, onClose }) {

	return (
		<div className="brokerage-overlay">
			<BrokerageOrderForm
				x={x}
				instrumentLabel={instrumentLabel}
				instrumentIsin={instrumentIsin}
				custodyCountry={custodyCountry}
				initialOrder={{
					depotId: '',
					settlementAccountId: '',
					instrumentId,
					venueId: '',
					side: 'BUY',
					quantity: '',
					limitPrice: '',
				}}
				onCancel={onClose}
				onDone={onClose}
			/>
		</div>
	);
}
